<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
               [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode"
               [title]="title" [code]="code" [labelWidth]="labelWidth" [validationRules]="validationRulesMap"
               [validationV2]="validationV2" [warningMessage]="warningMessage"
               [acceptZeroValue]="acceptZeroValue"
               (handleValueChange)="handleValueChange($event)" [isShowInfo]="isShowInfo" (codeChanges)="code = $event"
               (searchClick)="searchClick()"
               (clear)="clear()"
               [isShowViewBtn]="isShowViewBtn" (viewBtnClick)="viewButtonlick($event)"
               (showInfo)="showInfo($event)" [tabIndex]="-1">
</dk-ctl-sablon>
<dx-popup *ngIf="crudPopupVisible"
          title="Kişi Arama"
          [resizeEnabled]="false"
          [hideOnOutsideClick]="false"
          [showCloseButton]="true"
          [(visible)]="crudPopupVisible"
          (onHiding)="closePopupAfter($event, sablonCmp)"
>
  <dk-ctl-gen-kisi-arama
    [control]="control"
    [filterColumn]="filterColumn"
    [filterColumnValue]="filterColumnValue"
    [filterExpression]="altAramaFilter"
    (closePopup)="closePopupAfter($event, sablonCmp)"
    [filterArray]="filterArray"
  ></dk-ctl-gen-kisi-arama>
</dx-popup>
<!-- DKM-5213 Cedric: eski hâli -->
<!-- <div *ngIf="data && isShowInfo"> -->
<!-- DKM-5213: isShowInfo önce — kapalıyken ifade hep false kalır; kayıt değişiminde data undefined→nesne olunca NG0100 oluşmaz (davranış aynı) -->
<div *ngIf="isShowInfo && data">
  <dx-popup
    showEvent="click"
    [width]="350"
    [height]="150"
    [shading]="true"
    [title]="'Bilgiler'"
    [showCloseButton]="true"
    (onHiding)="showInfoPopup()"
    shadingColor="rgba(0, 0, 0, 0.5)"
    [visible]="crudInfoPopoverVisible"
  >
    <div class="info-area">
      <span><span class="info-header-text">Tc Kimlik No :</span> {{data?.Tckn}}</span>
      <span><span class="info-header-text">Adresi :</span> {{dataAdres?.Aciklama}}</span>
      <span><span class="info-header-text">Telefon :</span> {{dataIletisim?.AlanAd}}</span>
      <span><span class="info-header-text">Vergi No :</span> {{data?.VergiNo}}</span>
    </div>
    <dxo-position my="top" at="top" [of]="target">
    </dxo-position>
  </dx-popup>
</div>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
